import {
	IAssessRisk
} from '@assetmark/risk-components/dist/components/assess/assess';
import { ERiskPageType } from '@assetmark/risk-components/dist/models/riskPageType';
import { TQuestionData } from '@assetmark/risk-components/dist/models/riskQuestion.model';
import { RiskAction } from './risk.action';
import {
	UPDATE_RISK_DATA,
	UPDATE_RANGE_DATA,
	UPDATE_INVEST_RETURN_DATA,
	UPDATE_MAX_DECLINE_DATA,
	UPDATE_STOCK_MARKET_DATA,
	UPDATE_AGE_RANGE_DATA,
	UPDATE_PLANNED_DATA,
	UPDATE_SIDEBAR_TEXT_DATA
} from './risk.constant';
import { TRiskProfileResponse, TSidebarText } from '../../models/risk-profile.model';
import { TRiskQuestion } from '../../models/risk-question.model';

export type RiskContextState = {
	assessData: IAssessRisk;
	riskSidebarText: TSidebarText;
	updateRiskData: (riskQusData: Array<TRiskQuestion>) => void;
	updateInvestmentRangeData: (riskRangeData: Array<TRiskProfileResponse>) => void;
	// updateRiskProfileDataOnClick: (type: any, actionPayoad: TQuestionData) => void;
	updateRiskSidebarTextOnClick: (type: any, actionPayoad: TSidebarText) => void;

};
const emptyQuestionData = {} as TQuestionData;
export const initialState: RiskContextState = {
	assessData: {
		currentRiskSequence: ERiskPageType.InvestmentReturn,
		investmentAmount: 100000,
		investmentInfo: emptyQuestionData,
		maximumDecline: emptyQuestionData,
		stockMarketForecast: emptyQuestionData,
		ageRange: emptyQuestionData,
		plannedWithdrawal: emptyQuestionData,
		invesetmentRangeData: []
	},
	riskSidebarText: {
		investmentText:'',
		maxDeclineText:'',
		stockMarketText:'',
		ageRangeText: '',
		withdrawalText:''
	},
	updateRiskData: (riskQusData: Array<TRiskQuestion>) => {},
	updateInvestmentRangeData: (riskRangeData: Array<TRiskProfileResponse>) => {},
	updateRiskSidebarTextOnClick: (type: any, actionPayoad: TSidebarText) => {}
};

export function riskContextReducer(state: RiskContextState, action: RiskAction) {
	switch (action.type) {
        case UPDATE_RISK_DATA: {
            return {
				...state,
				riskQustions: action.payload
			};
        }
		case UPDATE_INVEST_RETURN_DATA: {
            return {
				...state,
				assessData: { ...state.assessData, investmentInfo: action.payload },
				riskSidebarText: { ...state.riskSidebarText, investmentText: action.text }
			};
        }
		case UPDATE_MAX_DECLINE_DATA: {
            return {
				...state,
				assessData: { ...state.assessData, maximumDecline: action.payload },
				riskSidebarText: { ...state.riskSidebarText, maxDeclineText: action.text }
			};
        }
		case UPDATE_STOCK_MARKET_DATA: {
            return {
				...state,
				assessData: { ...state.assessData, stockMarketForecast: action.payload },
				riskSidebarText: { ...state.riskSidebarText, stockMarketText: action.text }
			};
        }
		case UPDATE_AGE_RANGE_DATA: {
            return {
				...state,
				assessData: { ...state.assessData, ageRange: action.payload },
				riskSidebarText: { ...state.riskSidebarText, ageRangeText: action.text }
			};
        }
		case UPDATE_PLANNED_DATA: {
            return {
				...state,
				assessData: { ...state.assessData, plannedWithdrawal: action.payload },
				riskSidebarText: { ...state.riskSidebarText, withdrawalText: action.text }
			};
        }
		case UPDATE_RANGE_DATA: {
			return {
				...state,
				assessData: { ...state.assessData, invesetmentRangeData: action.payload }
			};
		}
		case UPDATE_SIDEBAR_TEXT_DATA: {
			return {
				...state,
				riskSidebarText: action.payload
			};
		}
		default: {
			throw new Error(`Unhandled action type: ${action}`);
		}
	}
}
